const Modal = ({ content, setContent }: any) => {
  return (
    <div className="bg-gray-900 bg-opacity-75 w-full h-full items-center justify-center flex z-40 fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" style={{ zIndex: 99 }}>
      <div className="bg-gray-900 lg:px-12 px-1 py-6 rounded-3xl flex-col">
        <p className=" text-center">{content.message}</p>
        {/* Se estiver enviando, ele ainda não exibe os botões */}
        {(content.message !== 'Enviando...' && content.message !== 'Carregando') &&
          (<div className="flex items-center justify-around py-4 lg:px-4">
            {/* Se for página de Login, não teremos botões com âncora <a> */}
            {(content.pathname !== '/login') ? (<a href="/wines" className="bg-dark-2 text-white p-4 shadow-md m-1">Voltar</a>) : null}
            <button onClick={() => setContent({ ...content, ativo: false })} className="bg-dark-2 text-white p-4 shadow-md m-1">Ficar na página</button>
            {(content.pathname !== '/login') ? (<a href="/wines/create" className="bg-dark-2 text-white p-4 shadow-md m-1">Novo item</a>) : null}
          </div>)}
      </div>
    </div>
  )
}
export default Modal
